module.exports = __webpack_public_path__ + "static/media/sample_vehicle_details.723657dd.csv";